import React, { useState, useRef, useEffect } from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import DonateForm from "../DonateForm";
import Logo from "../Logo";



const Nav = () => {
  
  const [showNav, setShowNav] = useState(false);

  const checkboxRef = useRef();

  const handleToggleNav = (e) => {
    setShowNav(!showNav);
    checkboxRef.current.checked = !checkboxRef.current.checked;
  }

  const bannerElementRef = useRef();
  const navContainerRef = useRef();
  useOnClickOutside(navContainerRef, () => {
    setShowNav(false);
    checkboxRef.current.checked = false;
  })
  
  const [hasLeft, setHasLeft] = useState(false);

  useEffect(() => {
    if ( ! bannerElementRef.current ) return;
    
    let observer;
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: [0.6,1]
    };
    observer = new IntersectionObserver(( entries ) => {
      if ( entries[0].intersectionRatio < 0.8 ) {
        setHasLeft(true);
      }
      else {
        setHasLeft(false);
      }
    }, options);
    observer.observe( bannerElementRef.current );

    return () => observer.disconnect();
    
  }, []);

  let theClassName = "";

  theClassName = hasLeft ? `${theClassName} has-left` : theClassName;

  return (
    <>
      <input id="navToggle" type="checkbox" hidden ref={checkboxRef} />
      <StyledBanner role="banner" className={theClassName} ref={bannerElementRef}>
        <Logo />
        <div ref={navContainerRef}>
          <NavToggle />
          <StyledNav>

            {sections.map((section, index) => (
              <div key={`footer-section-${index}`}>
                <strong>{section.title}</strong>
                {section.links.map((link, index) => (
                  <Link 
                    to={link.url} 
                    title={link.title} 
                    key={`footer-link-${index}`}
                    activeClassName="is-active"
                    onClick={handleToggleNav}
                  >{link.label}</Link>
                ))}
              </div>
            ))}
            <DonateForm />
          </StyledNav>
        </div>
        <DonateForm />
      </StyledBanner>
    </>
  );
};

export default Nav;

const StyledNav = styled.nav`
  position: absolute;
  color: var(--theme-text-against-dark);

  padding: 0.875em 0 0.625em;
  display: flex;
  flex-direction: column;
  gap: 2em;
  justify-content: space-between;
  padding: 3em;
  opacity: 0;
  transform: translate3d(calc(-100% - 3px),0,0);
  transition: transform 0.3s ease, opacity 0.2s ease 0.1s, left 0s linear 0.3s, right 0s linear 0.3s;
  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
  }
  &::before {
    backdrop-filter: blur(8px) contrast(1.3);
  }
  &::after {
    background-color: var(--theme-background-dark);
    opacity: 0.96;
  }

  form {
    display: block;
    button {
      background-color: var(--theme-background-light);
      color: var(--theme-text-against-light);
      padding: 0.75em 1em 0.5em;
      border-radius: 2em;
      font-weight: 700;
      font-size: 0.75em;
      text-transform: uppercase;
      letter-spacing: 0.1em;
      cursor: pointer;
    }
  }
  @media ( max-width: 60em ) {
    bottom: 0;
    width: 100vw;
    transform-origin: bottom right;

    position: fixed;
    //padding-left: 50%;
    top: 0;
    bottom: 0;
    left: 0;
    opacity: 1;

  }
  @media ( min-width: 60em ) {
    left: -999em;
    box-shadow: 0 0 0 1px rgba(255,255,255,0.2);
    input:checked ~ header & {
      left: 0;
    }
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    opacity: 1;
    &::after {
      opacity: 0.92;
    }
  }

  input:checked ~ header & {
    transition: transform 0.3s ease, opacity 0.1s ease, left 0s linear 0s, right 0s linear 0s;
    transform: translate3d(0,0,0);
    opacity: 1;
  }
  > div {
    display: flex;
    flex-direction: column;
    gap: 1.25em;
  }
  strong {
    font-size: 0.875em;
    font-family: var(--font-heading);
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    opacity: 0.3;
  }
  a {
    position: relative;
    display: grid;
    font-size: 1.25em;
    font-family: var(--font-heading);
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    line-height: 1;
    z-index: 0;
    transition: opacity 0.2s ease;
    
    .can-hover &:hover,
    &:active {
      opacity: 0.5;
    }
  }

`;


const StyledBanner = styled.header`
  position: sticky;
  top: 0;
  display: grid;
  margin-bottom: 3em;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    width: 100vw;
    margin-left: -50vw;
    z-index: -1;
    background-color: var(--theme-background-dark);
    opacity: 0;
    box-shadow: inset 0 -1px 0 rgba(255,255,255,0.2), 0 0 0.375em -0.125em rgba(0,0,0,0.4);
    transition: opacity 0.2s ease;
    //box-shadow: 0 0 0.375em -0.125em rgba(0,0,0,0.4);
  }
  @media ( max-width: 48em ) {
    &::before {
    }
  }
  &.has-left::before {
    opacity: 1;
  }
  padding: 2.5em var(--gutter) 0.5em;
  top: -2em;
  font-family: var(--font-heading);
  z-index: 100;
  > div {
    position: relative;
  }
  > form {
    position: relative;
    justify-self: end;
    align-self: stretch;
    button {
      padding: 0.125em 0.25em 0 0.3em;
      display: grid;
      place-items: center;
      height: 100%;
      cursor: pointer;
      border-radius: 1em;
      padding: 0.125em 1em 0;
      color: var(--theme-text-against-light);
      &::before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: -1;
        background-color: var(--theme-background-light);
        opacity: 1;
        border-radius: inherit;
        transition: opacity 0.2s ease;
      }
      span {
        position: relative;
        z-index: 0;
        transform: translate3d(0,0,0);
        font-size: 0.75em;
        font-weight: 700;
        text-transform: uppercase;
        line-height: 1;
        letter-spacing: 0.1em;
        transition: color 0.2s ease;
      }
    }
  }
  @media ( max-width: 60em ) {
    > div {
      position: fixed;
      bottom: 0.5em;
      right: 0.5em;
    }
    > form {
      display: none;
    }
  }
  .can-hover & > form button:hover,
  & > form button:active {
    &::before {
      opacity: 1;
    }
    span {
      color: var(--theme-text-against-light);
    }
  }
  @media ( min-width: 60em ) {
    grid-template-columns: 6.8125em 1fr 6.8125em;
    gap: 7em;
    align-items: center;
    padding-top: 2.5em;
    padding-bottom: 0.5em;
    top: -2em;
    > div {
      grid-row: 1;
      grid-column: 1;
    }
  }
`;


const NavToggle = () => {

  const handleToggle = (e) => {
    e.preventDefault(); 
    //toggleNavDrawerVisibility();
  }

  const navDrawerVisibility = false;
  return (
    <StyledNavToggle 
      htmlFor="navToggle" 
      tabIndex="0"
    >
      <StyledNavToggleIcon className={navDrawerVisibility ? `nav-opened` : undefined} />
      <span>Index</span>
    </StyledNavToggle>
  );
};

const StyledNavToggleIcon = styled.i`

  @keyframes top-in {
    0% {
      transform: translate3d(0,-4px,0);
    }
    60% {
      transform: translate3d(0,0,0);
    }
    100% {
      transform: translate3d(0,0,0) rotate(45deg);
    }
  }
  @keyframes top-out {
    0% {
      transform: translate3d(0,0,0) rotate(45deg);
    }
    60% {
      transform: translate3d(0,0,0);
    }
    100% {
      transform: translate3d(0,-4px,0);
    }
  }
  @keyframes bottom-in {
    0% {
      transform: translate3d(0,4px,0);
    }
    60% {
      transform: translate3d(0,0,0);
    }
    100% {
      transform: translate3d(0,0,0) rotate(-45deg);
    }
  }
  @keyframes bottom-out {
    0% {
      transform: translate3d(0,0,0) rotate(-45deg);
    }
    60% {
      transform: translate3d(0,0,0);
    }
    100% {
      transform: translate3d(0,4px,0);
    }
  }
  position: relative;
  z-index: 1000;
  display: block;
  height: 1.75em;
  width: 1.75em;
  transition: transform 0.4s ease;
  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: calc(50% - 1.5px);
    width: 100%;
    height: 3px;
    background-color: currentColor;
    transition: transform 0.4s ease;
  }
  &::before {
    animation: top-out 0.4s ease forwards;
  }
  &::after {
    animation: bottom-out 0.4s ease forwards;
  }
  #navToggle:checked ~ * &,
  &.nav-opened {
    transform: scale(0.8);
    &::before {
      animation: top-in 0.4s ease forwards;

    }
    &::after {
      animation: bottom-in 0.4s ease forwards;
    }
  }
`

const StyledNavToggle = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.75em;
  padding: 0;
  justify-self: start;  
  cursor: pointer;
  @media ( max-width: 60em ) {
    background-color: var(--theme-background-light);
    color: var(--theme-text-against-light);
    padding: 0.75em;
    z-index: 1;
    transform-origin: bottom right;
    transform: translate3d(0,0,0) scale(0.9);
    border-radius: 50%;
  }
  span {
    font-size: 0.75em;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 1;
    letter-spacing: 0.1em;
    transition: opacity 0.2s ease;
    margin: 0;
    transform: translate3d(0,0.075em,0);
    @media ( max-width: 48em ) {
      display: none;
    }
  }
  #navToggle:checked ~ * &,
  &.nav-opened {
    span {
      opacity: 0 !important;
    }
  }

`;

const sections = [
  {
    title: "Journalism",
    links: [
      {
        title: "Reporting",
        url: "/reporting",
        label: "Reporting"
      },
      {
        title: "Podcast",
        url: "/the-outlaw-ocean-podcast",
        label: "Podcast"
      },
      {
        title: "Dispatches from The Outlaw Ocean",
        url: "/dispatches",
        label: "Dispatches"
      },
      {
        title: "The Outlaw Ocean by Ian Urbina",
        url: "/the-outlaw-ocean-by-ian-urbina",
        label: "Book"
      }
    ]
  },
  {
    title: "Initiatives",
    links: [
      {
        title: "The Outlaw Ocean Institute",
        url: "/the-outlaw-ocean-institute",
        label: "Institute"
      },
      {
        title: "The Outlaw Ocean Mural Project",
        url: "/the-outlaw-ocean-mural-project",
        label: "Murals"
      },
      {
        title: "The Outlaw Ocean Music Project",
        url: "/the-outlaw-ocean-music-project",
        label: "Music"
      }
    ]
  },
  {
    title: "Organization",
    links: [
      {
        title: "About",
        url: "/about",
        label: "About"
      },
      {
        title: "Coverage",
        url: "/coverage",
        label: "Coverage"
      }
    ]
  }
];


const navLinks = [
  {
    to: "/reporting",
    label: "Reporting",
    title: "Reporting from The Outlaw Ocean Project"
  },
  {
    to: "/the-outlaw-ocean-podcast",
    label: "Podcast",
    title: "Listen to The Outlaw Ocean Podcast"
  },
  {
    to: "/dispatches",
    label: "Dispatches",
    title: "Dispatches from The Outlaw Ocean"
  },
  {
    to: "/the-outlaw-ocean-institute",
    label: "Institute",
    title: "The Outlaw Ocean Institute"
  },
  {
    to: "/coverage",
    label: "Coverage",
    title: "Coverage of The Outlaw Ocean Project"
  },
  {
    to: "/about",
    label: "About",
    title: "About The Outlaw Ocean Project Non-Profit"
  },
  {
    to: "/music-project",
    label: "Music",
    title: "The Outlaw Ocean Music Project"
  },
  {
    to: "/mural-project",
    label: "Murals",
    title: "The Outlaw Ocean Mural Project"
  },
  {
    to: "/the-outlaw-ocean-by-ian-urbina",
    label: "Book",
    title: "The Outlaw Ocean by Ian Urbina"
  }
];